<template>
  <div>
    <modal v-model="showFormError" effect="fade">
      <div slot="modal-header" class="modal-header">
        <span class="modal-title text-danger" style="font-size:16px"
          >Please fill all the required fields to complete the registration in the below sections:</span
        >
      </div>
      <ul class="form-error-message" style="margin:0; padding-left:15px">
        <li v-for="error in formErrorMessage" :key="error">{{ error }}</li>
      </ul>
      <div slot="modal-footer" class="modal-footer">
        <button id="ok" type="button" class="btn btn-sm btn-primary" @click="showFormError = false">OK</button>
      </div>
    </modal>

    <modal v-model="showRegistrationError" effect="fade">
      <div slot="modal-header" class="modal-header">
        <span class="modal-title text-danger" style="font-size:16px">Response Message: </span>
      </div>
      <ul class="form-error-message" style="margin:0; padding-left:15px">
        <li>{{ registrationErrMsg }}</li>
      </ul>
      <div slot="modal-footer" class="modal-footer">
        <button id="ok" type="button" class="btn btn-sm btn-primary" @click="continueDraft">Resume Draft</button>
        <button id="ok" type="button" class="btn btn-sm btn-primary" @click="showRegistrationError = false">Ok</button>
      </div>
    </modal>

    <modal v-model="showEmailForm" :backdrop="backdrop" width="470px" @cancel="gotoHome">
      <div slot="modal-header" class="modal-header">
        <span class="welcomeHeader" style="font-size: 20px">Welcome!</span>
      </div>
      <div>
        <p>
          Please enter your email to start myCFM's New Agreement Form. <br />
          You can save a draft and come back at any point.
        </p>
        <input
          v-model="userEmailAddress"
          style="margin:auto"
          type="email"
          class="form-control"
          placeholder="Email address"
          @blur="$v.userEmailAddress.$touch()"
        />
        <div v-if="!$v.userEmailAddress.email && $v.userEmailAddress.$error" class="text-center text-danger">
          Please enter a valid email address.
        </div>
        <div v-if="!$v.userEmailAddress.required && $v.userEmailAddress.$error" class="text-center text-danger">
          Please enter email address.
        </div>
        <div v-if="!$v.userEmailAddress.maxLength && $v.userEmailAddress.$error" class="text-center text-danger">
          Allowed upto 150 characters only
        </div>
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button class="btn btn-sm btn-default" @click="gotoHome">Cancel</button>
        <button class="btn btn-sm btn-default" @click="gotoResumeDraft">Resume Draft</button>
        <button class="btn btn-sm btn-primary" @click="submitEmail">Submit</button>
      </div>
    </modal>

    <div>
      <BotControlAOB
        :display-data="showRecaptcha"
        @closeModal="showRecaptcha = false"
        @recaptchaResponseData="submitDraftForm"
      />
    </div>

    <div v-show="showView == 'company'" class="container-fluid component">
      <div>
        <help portal="mycfm" class="pull-right padding-80" />
        <button class="btn btn-sm btn-primary btn-resume-draft pull-right" @click="displayCaptcha()">
          Save as Draft & Exit
        </button>
      </div>
      <p class="h4 heading branding">Company Information</p>
      <p>
        Please complete all of the required fields below (marked with an <span class="text-danger"><b>*</b></span
        >) to register your company with CFM. Hover over the <i class="fa fa-question-circle"></i> icon for additional help.
      </p>
      <p>
        Note that this form is for CFM products only. If interested in GE Aerospace products, please visit 
        <a :href = myGEAURL target="_blank" style="text-decoration: underline;">myGEAerospace.com</a>
      </p>
      <p>
        Why do we ask for so much information? Due to our work with the US government and global entities,
        CFM's compliance policies require specific due diligence.
      </p>
      <accordion ref="accordian" type="default" one-at-atime>
        <!-- general info -->
        <panel id="generalInfo" header="General Company Information" is-open>
          <general-company-information
            @next="nextTab"
            @addnewproduct="clearPanelGroup"
            @changecompany="clearPanelGroup"
          />
        </panel>
        <!-- company location -->
        <panel
          v-show="panelGroup.includes('companyLocation')"
          id="companyLocation"
          header="Company Location Information"
        >
          <company-location-info @next="nextTab" />
        </panel>
        <!-- MRO -->
        <panel
          v-show="showMRO && panelGroup.includes('mro')"
          id="mro"
          header="Product Information - Commercial Engines"
        >
          <mro-details portal="mygea" @next="nextTab" />
        </panel>
        <!-- product info Commercial -->
        <panel
          v-show="showProductInfoCommercial && panelGroup.includes('productInfoCommercial')"
          id="productInfoCommercial"
          header="Product Information - Commercial Engines"
        >
          <productinfo-commercial @next="nextTab" />
        </panel>
        <!-- product info airframe -->
        <panel
          v-show="showProductInfoAirframe && panelGroup.includes('productInfoAirframe')"
          id="productInfoAirframe"
          header="Product Information - Airframe Systems"
        >
          <productinfo-airframe @next="nextTab" />
        </panel>
        <!-- product info BGA -->
        <panel
          v-show="showProductInfoBGA && panelGroup.includes('productInfoBGA')"
          id="productInfoBGA"
          header="Product Information - Business & General Aviation Engines"
        >
          <productinfo-bga @next="nextTab" />
        </panel>
        <!-- terms and conditions -->
        <panel
          v-show="panelGroup.includes('termsAndConditions')"
          id="termsAndConditions"
          header="Terms & Acknowledgement"
        >
          <terms-acknowledgement @complete="showUserDetails" />
        </panel>
      </accordion>
    </div>
    <div v-if="showView == 'user'" class="container-fluid component">
      <user-details portal="mygea" @complete="registerCompany" @back="backToRegistration" />
    </div>
    <!-- loader -->
    <spinner
      ref="spinner"
      v-model="showSpinner"
      fixed
      size="lg"
      text="Please be patient we are processing your request. Please do not hit the back button / resubmit or a duplicate request may be created."
    />
  </div>
</template>
<script>
import accordion from "build-ui-x/src/Accordion";
import panel from "build-ui-x/src/Panel";
import generalCompanyInformation from "@/mycfm/components/new-company/GeneralCompanyInformation";
import companyLocationInfo from "@/mycfm/components/new-company/CompanyLocationInformation";
import mroDetails from "@/mycfm/components/new-company/MroDetails";
import termsAcknowledgement from "@/mycfm/components/new-company/TermsAcknowledgement";
import { registerCompany } from "@/services/endpointsService";
import spinner from "build-ui-x/src/Spinner";
import productinfoAirframe from "@/mycfm/components/new-company/ProductInformationAirframe";
import productinfoCommercial from "@/mycfm/components/new-company/ProductInformationCommercial";
import productinfoBga from "@/mycfm/components/new-company/ProductInformationBGA";
import userDetails from "@/mycfm/components/new-company/UserDetails";
import modal from "build-ui-x/src/Modal";
import help from "@/mycfm/components/HelpInfo";
import { mapState } from "vuex";
import moment from "moment";
import BotControlAOB from "@/mycfm/components/new-company/BotControlAOB";
import { email, required, maxLength } from "vuelidate/lib/validators";

export default {
  components: {
    accordion,
    panel,
    generalCompanyInformation,
    companyLocationInfo,
    mroDetails,
    termsAcknowledgement,
    spinner,
    productinfoCommercial,
    productinfoAirframe,
    productinfoBga,
    userDetails,
    modal,
    help,
    BotControlAOB
  },
  data() {
    return {
      showView: "company",
      showSpinner: false,
      panelGroup: [],
      recaptchaResponse: null,
      formErrorMessage: [],
      showFormError: false,
      validateDraftFields: true,
      showRecaptcha: false,
      showRegistrationError: false,
      registrationErrMsg: "",
      userEmailAddress: "",
      showEmailForm: false,
      backdrop: false,
      allDocTypes: [
        "LegalNameChangeDocument",
        "FAAPart145RepairStationCertificate",
        "CapabilitiesListDocument",
        "OperatorSpecification",
        "AirworthinessAuthorityDocumentation",
        "UpdatedContactsList",
        "DataProtectionPlanDocument",
        "CommercialFleetSummaryDocument",
        "CommercialOperatorCertificate",
        "CommercialOperatorSpecDocument",
        "LeaseAgreementCertificate",
        "BillOfSaleDocument",
        "AssetDocument",
        "AuthLetterDocument",
        "LetterOfDelegation",
        "FleetSummaryDocument",
        "OperatorCertDocument",
        "CAMOCertification",
        "RepairServicesOrOtherAgreementWithGEDocument",
        "VerificationOfConsultancyDocument",
        "OtherDocument",
        "BGACapabilitiesListDocument",
        "BGADataProtectionPlanDocument",
        "BGAFAAPart145RepairStationCertificate",
        "BGARatingLimitationDocument",
        "CommercialRelationshipDocument",
        "CompanyVerificationDocument"
      ],
      newlyDocs: {},
      companyDetails: {}
    };
  },
  computed: {
    myGEAURL() {
      if (this.environment == "prod") {
        return "https://my.geaerospace.com/access/#/company-registration";
      } else if (this.environment == "dev") {
        return "https://dev.my.geaerospace.com/access/#/company-registration";
      } else {
        return "https://qa.my.geaerospace.com/access/#/company-registration";
      }
    },
    showMRO() {
      return !this.$store.state.company.company.purchaseNewEngine && this.$store.state.mro.productMRO;
    },
    showProductInfoCommercial() {
      return (
        !this.$store.state.company.company.purchaseNewEngine &&
        this.$store.state.product.productTypes.commercial &&
        this.$store.state.product.productTypes.commercial.productInfo
      );
    },
    showProductInfoAirframe() {
      return (
        this.$store.state.product.productTypes.airframe && this.$store.state.product.productTypes.airframe.productInfo
      );
    },
    showProductInfoBGA() {
      return this.$store.state.product.productTypes.bga && this.$store.state.product.productTypes.bga.productInfo;
    },
    ...mapState("user", ["user"]),
    ...mapState("env", ["environment"])
  },
  created() {
    let userEmail = sessionStorage.getItem("company-user-email");
    if (userEmail) {
      this.$store.dispatch("user/setEmail", userEmail);
      this.$store.dispatch("companyUser/setEmail", userEmail);
    } else {
      // ask for user email
      this.showEmailForm = true;
    }
  },
  validations: {
    userEmailAddress: {
      required,
      email,
      maxLength: maxLength(150)
    }
  },
  methods: {
    displayCaptcha() {
      // check for purchase new engines selection
      if (this.$store.state.company.company.purchaseNewEngine == null) {
        alert("Please select Are you a prospective customer looking to purchase new (non-used) engines?");
        return;
      }

      //check for product type & Company type selection
      let productTypes = this.$store.state["product"].productTypes;

      let productInputs = ["commercial", "bga", "airframe"];

      for (let i = 0; i < productInputs.length; i++) {
        if (
          productTypes[productInputs[i]] != null &&
          productTypes[productInputs[i]].companyDetails.companyTypeId != ""
        ) {
          this.validateDraftFields = false;
        }
      }

      //resetting the flag for draft valdiations
      if (productTypes["commercial"] == null && productTypes["airframe"] == null && productTypes["bga"] == null) {
        this.validateDraftFields = true;
      }

      if (this.validateDraftFields) {
        alert("Please select the Product & Company Types.");
        return;
      }
      this.showRecaptcha = true;
      if (window.grecaptcha) {
        window.grecaptcha.reset();
      }
    },
    showUserDetails() {
      // alert all errors
      let vuelidateStore = this.$store.state.vuealidate;
      this.formErrorMessage = [];

      for (let key in vuelidateStore) {
        if (vuelidateStore[key].$error) {
          this.formErrorMessage.push(key);
          this.showFormError = true;
        }
      }
      if (!this.showFormError) {
        this.showView = "user";
      }
    },
    backToRegistration() {
      this.showView = "company";
    },
    submitDraftForm(data) {
      this.registerCompany(true, data);
    },
    continueDraft() {
      this.$router.push("/resume-draft");
      window.location.reload();
    },
    getUpdateSection(documentType) {
      let section = "";

      let genInfoDocType = ["LegalNameChangeDocument", "CompanyVerificationDocument"];
      let mroDocTypes = [
        "FAAPart145RepairStationCertificate",
        "CapabilitiesListDocument",
        "OperatorSpecification",
        "AirworthinessAuthorityDocumentation",
        "UpdatedContactsList",
        "DataProtectionPlanDocument",
        "CAMOCertification",
        "RepairServicesOrOtherAgreementWithGEDocument",
        "VerificationOfConsultancyDocument",
        "OtherDocument"
      ];
      let commercialProdDocTypes = [
        "CommercialFleetSummaryDocument",
        "CommercialOperatorCertificate",
        "CommercialOperatorSpecDocument",
        "LeaseAgreementCertificate",
        "BillOfSaleDocument",
        "AssetDocument",
        "AuthLetterDocument",
        "CommercialRelationshipDocument"
      ];
      let airframeProdDocType = ["LetterOfDelegation"];
      let bgaProdDocType = [
        "FleetSummaryDocument",
        "OperatorCertDocument",
        "BGACapabilitiesListDocument",
        "BGADataProtectionPlanDocument",
        "BGAFAAPart145RepairStationCertificate",
        "BGARatingLimitationDocument"
      ];

      if (genInfoDocType.indexOf(documentType) !== -1) {
        section = "company";
      }

      if (mroDocTypes.indexOf(documentType) !== -1) {
        section = "mro";
      }

      if (commercialProdDocTypes.indexOf(documentType) !== -1) {
        section = "commercial";
      }

      if (airframeProdDocType.indexOf(documentType) !== -1) {
        section = "airframe";
      }

      if (bgaProdDocType.indexOf(documentType) !== -1) {
        section = "bga";
      }
      return section;
    },
    updateDocSection(updateSection, docType, action) {
      let deleteDoc = {};
      if (action == "delete") {
        deleteDoc = this.$store.state["s3Docs"].s3Docs[docType];
      } else {
        deleteDoc = {
          documentName: "",
          documentType: docType,
          documentExtn: "",
          action: action,
          status: ""
        };
      }

      if (updateSection == "company") {
        let doc = {
          documentName: deleteDoc.documentName,
          documentType: docType,
          documentExtn: "",
          action: action,
          status: ""
        };
        if (action == "delete") {
          this.companyDetails.company.companyDocuments.push(doc);
          return;
        }
        this.companyDetails.company.companyDocuments.find(item => item.documentType == docType).action = action;
        return;
      }

      if (updateSection == "commercial") {
        let productTypes = this.companyDetails.productTypes;
        let doc = {
          documentName: deleteDoc.documentName,
          documentType: docType,
          documentExtn: "",
          action: action,
          status: ""
        };
        //if product itself is changed then add the whole json part with just doc details
        let isCommercialThere = productTypes.find(item => item.productTypeDesc == "Commercial Engines");
        if (isCommercialThere == undefined) {
          let prodInfo = {
            productTypeId: 1,
            productTypeDesc: "Commercial Engines",
            companyDetails: null,
            productInfo: { documents: [] }
          };
          prodInfo.productInfo.documents.push(doc);
          productTypes.push(prodInfo);
          return;
        } else {
          if (productTypes.find(item => item.productTypeDesc == "Commercial Engines").productInfo == null) {
            productTypes.find(item => item.productTypeDesc == "Commercial Engines").productInfo = { documents: [] };
            productTypes.find(item => item.productTypeDesc == "Commercial Engines").productInfo.documents.push(doc);
          } else {
            if (action == "delete") {
              productTypes.find(item => item.productTypeDesc == "Commercial Engines").productInfo.documents.push(doc);
              return;
            }
            productTypes
              .find(item => item.productTypeDesc == "Commercial Engines")
              .productInfo.documents.find(item => item.documentType == docType).action = action;
          }
        }
        return;
      }

      if (updateSection == "airframe") {
        let productTypes = this.companyDetails.productTypes;
        let doc = {
          documentName: deleteDoc.documentName,
          documentType: docType,
          documentExtn: "",
          action: action,
          status: ""
        };
        //if product itself is changed then add the whole json part with just doc details
        let isAirframeThere = productTypes.find(item => item.productTypeDesc == "Airframe Systems");
        if (isAirframeThere == undefined) {
          let prodInfo = {
            productTypeId: 2,
            productTypeDesc: "Airframe Systems",
            companyDetails: null,
            productInfo: { documents: [] }
          };
          prodInfo.productInfo.documents.push(doc);
          productTypes.push(prodInfo);
          return;
        } else {
          if (productTypes.find(item => item.productTypeDesc == "Airframe Systems").productInfo == null) {
            //if only companyType is changed,i.e.,action should be download always
            productTypes.find(item => item.productTypeDesc == "Airframe Systems").productInfo = { documents: [] };
            productTypes.find(item => item.productTypeDesc == "Airframe Systems").productInfo.documents.push(doc);
          } else {
            if (action == "delete") {
              productTypes.find(item => item.productTypeDesc == "Airframe Systems").productInfo.documents.push(doc);
              return;
            }
            productTypes
              .find(item => item.productTypeDesc == "Airframe Systems")
              .productInfo.documents.find(item => item.documentType == docType).action = action;
          }
        }
        return;
      }

      if (updateSection == "bga") {
        let productTypes = this.companyDetails.productTypes;
        let doc = {
          documentName: deleteDoc.documentName,
          documentType: docType,
          documentExtn: "",
          action: action,
          status: ""
        };
        //if product itself is changed then add the whole json part with just doc details
        let isBgaThere = productTypes.find(item => item.productTypeDesc == "Business & General Aviation Engines (BGA)");
        if (isBgaThere == undefined) {
          let prodInfo = {
            productTypeId: 4,
            productTypeDesc: "Business & General Aviation Engines (BGA)",
            companyDetails: null,
            productInfo: { documents: [] }
          };
          prodInfo.productInfo.documents.push(doc);
          productTypes.push(prodInfo);
          return;
        } else {
          if (
            productTypes.find(item => item.productTypeDesc == "Business & General Aviation Engines (BGA)")
              .productInfo == null
          ) {
            //if only companyType is changed,i.e.,action should be download always
            productTypes.find(
              item => item.productTypeDesc == "Business & General Aviation Engines (BGA)"
            ).productInfo = { documents: [] };
            productTypes
              .find(item => item.productTypeDesc == "Business & General Aviation Engines (BGA)")
              .productInfo.documents.push(doc);
          } else {
            if (action == "delete") {
              productTypes
                .find(item => item.productTypeDesc == "Business & General Aviation Engines (BGA)")
                .productInfo.documents.push(doc);
              return;
            }
            productTypes
              .find(item => item.productTypeDesc == "Business & General Aviation Engines (BGA)")
              .productInfo.documents.find(item => item.documentType == docType).action = action;
          }
        }
        return;
      }

      if (updateSection == "mro") {
        let doc = {
          documentName: deleteDoc.documentName,
          documentType: docType,
          documentExtn: "",
          action: action,
          status: ""
        };
        //if MRO is there then companyDetails.ProductMRO will be there if not then null.
        let isMROThere = this.companyDetails.productMRO != null ? true : false;
        if (isMROThere) {
          if (action == "delete") {
            this.companyDetails.productMRO.documents.push(doc);
            return;
          }
          this.companyDetails.productMRO.documents.find(item => item.documentType == docType).action = action;
        } else {
          this.companyDetails.productMRO = { documents: [] };
          this.companyDetails.productMRO.documents.push(doc);
        }
        return;
      }
    },
    registerCompany(saveDraft, recaptchaValue) {
      let formData = new FormData();
      let productStore = this.$store.state["product"].productTypes;
      this.companyDetails.productTypes = [];

      for (let product in productStore) {
        if (productStore[product] !== null) {
          //adding the new/updated productInfo docs .
          if (productStore[product].productInfo != null) {
            for (let j = 0; j < productStore[product].productInfo.documents.length; j++) {
              this.newlyDocs[productStore[product].productInfo.documents[j].documentType] =
                productStore[product].productInfo.documents[j];
            }
          }
          this.companyDetails.productTypes.push(productStore[product]);
        }
      }

      if (
        !(
          this.$store.state.product.productTypes.commercial !== null &&
          (this.$store.state.product.productTypes["commercial"].companyDetails.companyTypeId == "11" ||
            this.$store.state.product.productTypes["commercial"].companyDetails.companyTypeId == "12" ||
            this.$store.state.product.productTypes["commercial"].companyDetails.companyTypeId == "13" ||
            this.$store.state.product.productTypes["commercial"].companyDetails.companyTypeId == "14" ||
            this.$store.state.product.productTypes["commercial"].companyDetails.companyTypeId == "15" ||
            this.$store.state.product.productTypes["commercial"].companyDetails.companyTypeId == "16" ||
            this.$store.state.product.productTypes["commercial"].companyDetails.companyTypeId == "17" ||
            this.$store.state.product.productTypes["commercial"].companyDetails.companyTypeId == "18" ||
            this.$store.state.product.productTypes["commercial"].companyDetails.companyTypeId == "19")
        ) &&
        this.$store.state["mro"].productMRO !== null
      ) {
        this.$store.state["mro"].productMRO.engineDetails = undefined;
      }

      if (this.$store.state["company"].company.nameChangeDate) {
        this.$store.state["company"].company.nameChangeDate = moment(
          this.$store.state["company"].company.nameChangeDate
        ).format("MM/DD/YYYY");
      }

      //format date for greencardexpiry date of Compnany Location Info Access Required
      if (this.$store.state["company"].company.companyLocation.contactDetails.greenCardExpiry) {
        this.$store.state["company"].company.companyLocation.contactDetails.greenCardExpiry = moment(
          this.$store.state["company"].company.companyLocation.contactDetails.greenCardExpiry
        ).format("MM/DD/YYYY");
      }

      this.companyDetails.company = this.$store.state["company"].company;
      this.companyDetails.productMRO = this.$store.state["mro"].productMRO;
      this.companyDetails.termsAgreed = true;
      this.companyDetails.saveDraft = saveDraft;
      this.companyDetails.userDetails = this.$store.state["companyUser"].userDetails;
      this.companyDetails.aobRefNumber = this.$store.state["product"].referenceNumber;

      //adding the new/updated MRO docs .
      if (this.companyDetails.productMRO != null) {
        for (let i = 0; i < this.companyDetails.productMRO.documents.length; i++) {
          this.newlyDocs[
            this.companyDetails.productMRO.documents[i].documentType
          ] = this.companyDetails.productMRO.documents[i];
        }
      }

      //adding the new/updated Company docs .
      if (this.companyDetails.company != null) {
        for (let i = 0; i < this.companyDetails.company.companyDocuments.length; i++) {
          this.newlyDocs[
            this.companyDetails.company.companyDocuments[i].documentType
          ] = this.companyDetails.company.companyDocuments[i];
        }
      }

      if (saveDraft) {
        this.companyDetails.userDetails.email = this.user.email;

        for (let i = 0; i < this.allDocTypes.length; i++) {
          let s3Doc = this.$store.state["s3Docs"].s3Docs[this.allDocTypes[i]];
          let newDoc = this.newlyDocs[this.allDocTypes[i]];
          let updateSection = this.getUpdateSection(this.allDocTypes[i]);

          //if both are not there --> leave it as it is
          //then nothing needs to be done.

          //if not newly added but in s3 --> action="delete"
          if (s3Doc != undefined && newDoc == undefined) {
            this.updateDocSection(updateSection, this.allDocTypes[i], "delete");
          }

          //if in newly added but not in s3 --> action="add"
          if (s3Doc == undefined && newDoc != undefined) {
            this.updateDocSection(updateSection, this.allDocTypes[i], "add");
          }

          //if newly added as well as in s3 --> check if updated or not in both cases action=""
          if (s3Doc != undefined && newDoc != undefined) {
            if (newDoc.action == "add") {
              this.updateDocSection(updateSection, this.allDocTypes[i], "add");
            } else {
              this.updateDocSection(updateSection, this.allDocTypes[i], "");
            }
          }
        }
      } else {
        //if the referenceNumber is not there then nothing needs to be done.
        //if the referenceNumber is there then update the action.
        if (this.companyDetails.aobRefNumber == "") {
          //updating MOR details
          if (this.companyDetails.productMRO != null) {
            for (let i = 0; i < this.companyDetails.productMRO.documents.length; i++) {
              this.companyDetails.productMRO.documents[i].action = "submit";
            }
          }
          //updating product info documents
          for (let i = 0; i < this.companyDetails.productTypes.length; i++) {
            if (this.companyDetails.productTypes[i].productInfo != null) {
              for (let j = 0; j < this.companyDetails.productTypes[i].productInfo.documents.length; j++) {
                this.companyDetails.productTypes[i].productInfo.documents[j].action = "submit";
              }
            }
          }
          //updating Company Doc if it's there
          if (this.companyDetails.company != null) {
            for (let i = 0; i < this.companyDetails.company.companyDocuments.length; i++) {
              this.companyDetails.company.companyDocuments[i].action = "submit";
            }
          }
        } else {
          //updating MOR details
          if (this.companyDetails.productMRO != null) {
            for (let i = 0; i < this.companyDetails.productMRO.documents.length; i++) {
              if (this.companyDetails.productMRO.documents[i].action == "") {
                this.companyDetails.productMRO.documents[i].action = "reuse";
              } else {
                this.companyDetails.productMRO.documents[i].action = "submit";
              }
            }
          }
          //updating product info documents
          for (let i = 0; i < this.companyDetails.productTypes.length; i++) {
            if (this.companyDetails.productTypes[i].productInfo != null) {
              for (let j = 0; j < this.companyDetails.productTypes[i].productInfo.documents.length; j++) {
                if (this.companyDetails.productTypes[i].productInfo.documents[j].action == "") {
                  this.companyDetails.productTypes[i].productInfo.documents[j].action = "reuse";
                } else {
                  this.companyDetails.productTypes[i].productInfo.documents[j].action = "submit";
                }
              }
            }
          }
          //updating Company Doc if it's there
          if (this.companyDetails.company != null) {
            for (let i = 0; i < this.companyDetails.company.companyDocuments.length; i++) {
              if (this.companyDetails.company.companyDocuments[i].action == "") {
                this.companyDetails.company.companyDocuments[i].action = "reuse";
              } else {
                this.companyDetails.company.companyDocuments[i].action = "submit";
              }
            }
          }
        }
      }

      // update agreedTNC field for each selected product
      // commercial tnc
      if (this.$store.state.product.productTypes.commercial) {
        if (
          this.$store.getters["product/showCommercialTerms"] ||
          this.$store.getters["product/showCommercialTermsForBGA"]
        ) {
          this.$store.state.product.productTypes.commercial.agreedTNC = true;
        } else {
          this.$store.state.product.productTypes.commercial.agreedTNC = false;
        }
      }

      // update agreedTNC field for each selected product
      // commercial tnc
      if (this.$store.state.product.productTypes.commercial) {
        if (this.$store.getters["product/showCFMCommercialGeneralTerms"]) {
          this.$store.state.product.productTypes.commercial.agreedTNC = true;
        } else {
          this.$store.state.product.productTypes.commercial.agreedTNC = false;
        }
      }

      // airframe tnc
      if (this.$store.state.product.productTypes.airframe) {
        if (this.$store.getters["product/showAirframeTerms"]) {
          this.$store.state.product.productTypes.airframe.agreedTNC = true;
        } else {
          this.$store.state.product.productTypes.airframe.agreedTNC = false;
        }
      }

      // BGA tnc
      if (this.$store.state.product.productTypes.bga) {
        if (this.$store.getters["product/showBGATerms"]) {
          this.$store.state.product.productTypes.bga.agreedTNC = true;
        } else {
          this.$store.state.product.productTypes.bga.agreedTNC = false;
        }
      }

      formData.append("companyRegistrationRequestString", JSON.stringify(this.companyDetails));

      // append files to form
      let filesStore = this.$store.state["files"].files;
      for (let file in filesStore) {
        formData.append(file, filesStore[file]);
      }

      // show loader
      this.showSpinner = true;
      // used in /success message display
      this.$store.dispatch("product/saveDraft", saveDraft);

      registerCompany(formData, recaptchaValue)
        .then(data => {
          this.$store.dispatch("product/setReferenceNumber", data.referenceNumber);
          this.$router.push("/success");
        })
        .catch(error => {
          if (
            error.response.data.errorMessage.toString().indexOf("submitted due to an intermittent connection issue") !==
            -1
          ) {
            this.registrationErrMsg = error.response.data.errorMessage;
            this.showRegistrationError = true;
          } else {
            alert(error.response.data.errorMessage);
          }
        })
        .finally(() => {
          // hide spinner
          this.showSpinner = false;
        });
    },
    clearPanelGroup() {
      // hide all sections but general info
      this.panelGroup.splice(1);
      // clear external vuealidate store
      this.$store.dispatch("vuealidate/clearValidation");
    },
    addToPanelGroup(panel) {
      if (!this.panelGroup.includes(panel)) {
        this.panelGroup.push(panel);
      }
    },
    nextTab(currentSection) {
      switch (currentSection) {
        case "GeneralInfo":
          this.openPanel("companyLocation");
          break;
        case "CompanyLocation":
          if (this.showMRO) {
            this.openPanel("mro");
          } else if (this.showProductInfoCommercial) {
            this.openPanel("productInfoCommercial");
          } else if (this.showProductInfoAirframe) {
            this.openPanel("productInfoAirframe");
          } else if (this.showProductInfoBGA) {
            this.openPanel("productInfoBGA");
          } else {
            this.openPanel("termsAndConditions");
          }
          break;
        case "MRO":
          if (this.showProductInfoCommercial) {
            this.openPanel("productInfoCommercial");
          } else if (this.showProductInfoAirframe) {
            this.openPanel("productInfoAirframe");
          } else if (this.showProductInfoBGA) {
            this.openPanel("productInfoBGA");
          } else {
            this.openPanel("termsAndConditions");
          }
          break;
        case "ProductInfoCommercial":
          if (this.showProductInfoAirframe) {
            this.openPanel("productInfoAirframe");
          } else if (this.showProductInfoBGA) {
            this.openPanel("productInfoBGA");
          } else {
            this.openPanel("termsAndConditions");
          }
          break;
        case "ProductInfoAirframe":
          if (this.showProductInfoBGA) {
            this.openPanel("productInfoBGA");
          } else {
            this.openPanel("termsAndConditions");
          }
          break;
        case "ProductInfoBGA":
          this.openPanel("termsAndConditions");
          break;
        default:
          this.openPanel("generalInfo");
      }
    },
    openPanel(panelName) {
      // add to display one by one
      this.addToPanelGroup(panelName);

      this.$refs["accordian"].$children.filter(panel => {
        if (panel.$attrs.id === panelName) {
          panel.open = true;
        } else {
          panel.open = false;
        }
      });
    },
    submitEmail() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        sessionStorage.setItem("company-user-email", this.userEmailAddress);
        this.$store.dispatch("user/setEmail", this.userEmailAddress);
        this.$store.dispatch("companyUser/setEmail", this.userEmailAddress);
        this.showEmailForm = false;
      }
    },
    gotoResumeDraft() {
      this.$router.push("resume-draft");
      window.location.reload();
    },
    gotoHome() {
      this.$router.push("/");
      window.location.reload();
    }
  }
};
</script>
<style scoped>
.welcomeHeader,
.branding {
  font-size: 23px;
  font-weight: bold;
  color: #004bbd;
  font-family: apexSans;
}
</style>
